/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Applicants_Bulk_Selected_CountInputs */

const en_applicants_bulk_selected_count = /** @type {(inputs: Applicants_Bulk_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} selected`)
};

const de_applicants_bulk_selected_count = /** @type {(inputs: Applicants_Bulk_Selected_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} markiert`)
};

/**
* | output |
* | --- |
* | "{count} selected" |
*
* @param {Applicants_Bulk_Selected_CountInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const applicants_bulk_selected_count = /** @type {((inputs: Applicants_Bulk_Selected_CountInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Applicants_Bulk_Selected_CountInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_applicants_bulk_selected_count(inputs)
	return en_applicants_bulk_selected_count(inputs)
});